
export class ServiceBase {
    id!: number;
    name!: string;
    code!: string;

    static fromService(service: Service): ServiceBase {

        let current = new ServiceBase();
        Object.assign(current, service);

        return current;
    }

}

export interface Service extends ServiceBase {

}